import React from "react";
import Modal from "./Modal";
import Button from "../Button/Button";

const SimpleConfirmModal = ({ onCancel, onConfirm, title }) => (
  <Modal className="simple" onClose={onCancel}>
    <div className="modal__header">{title}</div>
    <div className="modal__body">
      <div className="modal__body-buttons">
        <Button color="gray" onClick={onCancel}>
          Нет
        </Button>
        <Button color="blue" onClick={onConfirm}>
          Да
        </Button>
      </div>
    </div>
  </Modal>
);

export default SimpleConfirmModal;
